// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");

function empty(param) {
  return {
          id: undefined,
          name: "",
          subject: "",
          body: "",
          notificationRuleId: undefined,
          dataFields: undefined,
          reportIds: /* [] */0,
          timeFrame: undefined,
          includeSurveyResponses: false,
          deleted: false
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function subject(t) {
  return t.subject;
}

function body(t) {
  return t.body;
}

function dataFields(t) {
  return t.dataFields;
}

function notificationRuleId(t) {
  return t.notificationRuleId;
}

function reportIds(t) {
  return t.reportIds;
}

function timeFrame(t) {
  return t.timeFrame;
}

function includeSurveyResponses(t) {
  return t.includeSurveyResponses;
}

function deleted(t) {
  return t.deleted;
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setSubject(t, subject) {
  return {
          id: t.id,
          name: t.name,
          subject: subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setBody(t, body) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setNotificationRuleId(t, notificationRuleId) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setDataFields(t, dataFields) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setReportIds(t, reportIds) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setTimeFrame(t, timeFrame) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: t.deleted
        };
}

function setIncludeSurveyResponses(t, includeSurveyResponses) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: includeSurveyResponses,
          deleted: t.deleted
        };
}

function setDeleted(t, deleted) {
  return {
          id: t.id,
          name: t.name,
          subject: t.subject,
          body: t.body,
          notificationRuleId: t.notificationRuleId,
          dataFields: t.dataFields,
          reportIds: t.reportIds,
          timeFrame: t.timeFrame,
          includeSurveyResponses: t.includeSurveyResponses,
          deleted: deleted
        };
}

function decodeReportIds(json) {
  var obj = Js_json.decodeObject(json);
  if (obj === undefined) {
    return /* [] */0;
  }
  var v = Js_dict.get(obj, "report_ids");
  if (v !== undefined) {
    return Json_decode.list(Json_decode.$$int, v);
  }
  var v$1 = Js_dict.get(obj, "report_id");
  if (v$1 === undefined) {
    return /* [] */0;
  }
  var id = Json_decode.optional(Json_decode.$$int, v$1);
  if (id !== undefined) {
    return {
            hd: id,
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function decode(json) {
  var reportIds = decodeReportIds(json);
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          subject: Json_decode.field("subject", (function (param) {
                  return Json_decode.withDefault("", Json_decode.string, param);
                }), json),
          body: Json_decode.field("body", (function (param) {
                  return Json_decode.withDefault("", Json_decode.string, param);
                }), json),
          notificationRuleId: Json_decode.field("notification_rule_id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          dataFields: Json_decode.optional((function (param) {
                  return Json_decode.field("data_fields", (function (param) {
                                return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                              }), param);
                }), json),
          reportIds: reportIds,
          timeFrame: Json_decode.field("time_frame", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          includeSurveyResponses: Json_decode.field("include_survey_responses", (function (param) {
                  return Json_decode.withDefault(false, Json_decode.bool, param);
                }), json),
          deleted: false
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "subject",
                    t.subject
                  ],
                  tl: {
                    hd: [
                      "body",
                      t.body
                    ],
                    tl: {
                      hd: [
                        "notification_rule_id",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), t.notificationRuleId)
                      ],
                      tl: {
                        hd: [
                          "data_fields",
                          Json_encode.nullable((function (param) {
                                  return Json_encode.list(DataField$ReactHooksTemplate.encode, param);
                                }), t.dataFields)
                        ],
                        tl: {
                          hd: [
                            "report_ids",
                            Json_encode.array((function (prim) {
                                    return prim;
                                  }), Belt_List.toArray(t.reportIds))
                          ],
                          tl: {
                            hd: [
                              "time_frame",
                              Json_encode.nullable((function (prim) {
                                      return prim;
                                    }), t.timeFrame)
                            ],
                            tl: {
                              hd: [
                                "include_survey_responses",
                                t.includeSurveyResponses
                              ],
                              tl: {
                                hd: [
                                  "deleted",
                                  t.deleted
                                ],
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

exports.empty = empty;
exports.id = id;
exports.name = name;
exports.subject = subject;
exports.body = body;
exports.dataFields = dataFields;
exports.notificationRuleId = notificationRuleId;
exports.reportIds = reportIds;
exports.timeFrame = timeFrame;
exports.includeSurveyResponses = includeSurveyResponses;
exports.deleted = deleted;
exports.setName = setName;
exports.setSubject = setSubject;
exports.setBody = setBody;
exports.setNotificationRuleId = setNotificationRuleId;
exports.setDataFields = setDataFields;
exports.setReportIds = setReportIds;
exports.setTimeFrame = setTimeFrame;
exports.setIncludeSurveyResponses = setIncludeSurveyResponses;
exports.setDeleted = setDeleted;
exports.decode = decode;
exports.encode = encode;
/* DataField-ReactHooksTemplate Not a pure module */
